export default __webpack_public_path__ + "static/media/Diamond.f615955e.svg";